import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { ArticleTextComponent } from '@twisto/api-cms'

import { createIdFromSlugAndId } from 'homepage/utils'

export const Text = ({
  text,
  variant,
  id,
  color,
  component,
  fontWeight,
}: ArticleTextComponent) => (
  <Typography
    color={color}
    component={component}
    fontWeight={fontWeight}
    id={createIdFromSlugAndId('', id)}
    variant={variant}
  >
    {text}
  </Typography>
)
